import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AbilityRangeGenerator } from '../../../../utils/AssessmentUtil';

class Cognitive extends Component {
  render() {
    const { cognitive } = this.props;
    if (!cognitive) {
      return <div />;
    }
    const matchResult = cognitive.dimensionMatchResults;

    if (!matchResult) {
      return <div />;
    }
    const abilityRange = matchResult.map(r => AbilityRangeGenerator.generateRangeContainer(r));

    const panelHeader = (
      <div className="panel-header">
        <span className={`pull-right label ${AbilityRangeGenerator.mapOverallLabelToPercent(cognitive.matchPercent)}`}>
          {`${cognitive.matchPercent} %`}
        </span>
        <span>{cognitive.displayName}</span>
      </div>
    );
    return (
      <div className="ability">
        {abilityRange.length > 0 && panelHeader}
        {abilityRange}
      </div>
    );
  }
}

Cognitive.propTypes = {
  cognitive: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Cognitive;
